<template>
  <div class="cont-wrap error-page">
    <div class="num">404</div>
    <div class="title">{{ $t('system.notfound_title') }}</div>
    <div class="text" v-html="$t('system.notfound_text')"></div>
  </div>
</template>

<script>
export default {
  name: 'Error',
};
</script>

<style scoped lang="scss">
.error-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;
  padding: 120px 24px;
  .num {
    font-size: 240px;
    line-height: 100%;
    font-weight: 900;
  }
  .title {
    font-size: 22px;
    font-weight: 500;
  }
  .text {
    font-size: 14px;
    color: #9a9a9a;
  }
}
@media (max-width: 768px) {
  .error-page {
    .num {
      font-size: 108px;
    }
    .title {
      font-size: 20px;
    }
    .text {
      font-size: 12px;
      color: #9a9a9a;
    }
  }
}
</style>
